import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'vip-club-banner',
  templateUrl: './vip-club.component.html',
  styleUrl: './vip-club.component.scss',
  host: { class: 'lg:w-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink]
})
export default class VipClubBannerComponent {}
